import PropTypes from 'prop-types';

import { useAuth } from '../hooks';
import { hasActiveFeatureGate } from '../callbacks';

export const FEATURE_GATES = {
  AUTH_SSO: 'auth - sso',
  AUTHORISATION: 'authorisation',
  BROADCAST: 'broadcast',
  BUILDER: 'builder',
  CHANNEL_ALEXA: 'channel - alexa',
  CHANNEL_CONVERSE: 'channel - converse',
  CHANNEL_EMBEDDED: 'channel - embedded',
  CHANNEL_FACEBOOK_MESSENGER: 'channel - facebook messenger',
  CHANNEL_FACEBOOK_WORKPLACE: 'channel - facebook workplace',
  CHANNEL_FULL_PAGE: 'channel - full page',
  CHANNEL_INSTAGRAM: 'channel - instagram',
  CHANNEL_MICROSOFT_TEAMS: 'channel - microsoft teams',
  CHANNEL_RCS: 'channel - rcs',
  CHANNEL_SMS: 'channel - sms',
  CHANNEL_TELEGRAM: 'channel - telegram',
  CHANNEL_VIBER: 'channel - viber',
  CHANNEL_VOIP: 'channel - voip',
  CHANNEL_WHATSAPP: 'channel - whatsapp',
  CUSTOM_PASSWORD_EXPIRATION_PEIORD: 'custom password expiration period',
  EMAILS: 'emails',
  FAQ_REGRESSION_TESTING: 'faq regression testing',
  FEEDBACK: 'feedback',
  GENERATIVE_AI_SHAREPOINT: 'generative ai - sharepoint',
  GENERATIVE_AI_ZENDESK: 'generative ai - zendesk',
  GENERATIVE_AI: 'generative ai',
  INTEGRATIONS: 'integrations',
  KNOWLEDGE_BASES: 'knowledge bases',
  LANGUAGES: 'languages',
  LIVE_CHATS: 'live chats',
  MCP: 'mcp',
  OWNER_AREA: 'owner area',
  PAYMENTS: 'payments',
  S3_STORAGE: 's3 storage',
  SEMANTIC_SEARCH: 'semantic search',
  SENTIMENT_ANALYSIS: 'sentiment analysis',
  SMALL_TALK: 'small talk',
  TEMPLATING: 'templating',
  WHITELABEL_FOOTER: 'whitelabel footer',
};

const GlobalFeatureGateFilter = ({ children, for: featureGate }) => {
  const auth = useAuth();

  if (hasActiveFeatureGate(featureGate)(auth)) {
    return children;
  }

  return null;
};

GlobalFeatureGateFilter.propTypes = {
  for: PropTypes.oneOf(Object.values(FEATURE_GATES)).isRequired,
};

export default GlobalFeatureGateFilter;
